/**
 * @group UI
 * @summary Error type constants for error pages and components
 * 
 * @remarks
 * This constant contains error types used in error pages and error handling
 * components for consistent error categorization and messaging.
 * 
 * @example
 * ```typescript
 * import { ERROR_TYPES } from '@shared/constants';
 * 
 * if (error === ERROR_TYPES.PERMISSION_DENIED) {
 *   // Handle permission denied error
 * }
 * ```
 */
export const ERROR_TYPES = {
  PERMISSION_DENIED: 'permission_denied',
  NOT_FOUND: 'not_found',
  SERVER_ERROR: 'server_error',
  UNAUTHORIZED: 'unauthorized',
  FORBIDDEN: 'forbidden',
  VALIDATION_ERROR: 'validation_error',
  NETWORK_ERROR: 'network_error',
  TIMEOUT: 'timeout',
  RATE_LIMITED: 'rate_limited',
  MAINTENANCE: 'maintenance'
} as const;
